import type { ReactNode } from 'react'
import { Search, X } from 'lucide-react'
import { GESTOR_TAB_SEARCH_INPUT_CLASS } from '@/components/Gestores/gestorTabFiltersStyles'

type Props = {
  search: string
  onSearchChange: (v: string) => void
  searchPlaceholder: string
  searchAriaLabel: string
  onClearAll?: () => void
  showClear?: boolean
  children?: ReactNode
}

export function GestorTabFiltersBar({
  search,
  onSearchChange,
  searchPlaceholder,
  searchAriaLabel,
  onClearAll,
  showClear = false,
  children,
}: Props) {
  return (
    <div className='glass-card p-4'>
      <div className='grid w-full grid-cols-1 items-center gap-3 md:grid-cols-[minmax(0,1fr)_auto]'>
        <div className='closer-toolbar-field-shell relative min-w-0 overflow-hidden rounded-xl'>
          <Search
            size={16}
            className='pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-text-muted'
          />
          <input
            type='text'
            placeholder={searchPlaceholder}
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            aria-label={searchAriaLabel}
            className={GESTOR_TAB_SEARCH_INPUT_CLASS}
          />
          {search && (
            <button
              type='button'
              onClick={() => onSearchChange('')}
              className='absolute right-3 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-md text-text-muted transition-colors hover:text-red-500 dark:hover:text-red-400'
              aria-label='Limpar busca'
            >
              <X size={14} />
            </button>
          )}
        </div>

        {(children || showClear) && (
          <div className='flex shrink-0 flex-wrap items-center justify-end gap-3 md:justify-self-end'>
            {children}
            {showClear && onClearAll && (
              <button
                type='button'
                onClick={onClearAll}
                className='flex h-10 shrink-0 items-center gap-1.5 rounded-lg border border-red-500/20 bg-red-500/10 px-3 text-xs font-medium text-red-500 transition-all hover:bg-red-500/20 dark:text-red-400'
              >
                <X size={14} /> Limpar
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
